var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPenHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comp-table-row-edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 40,
    height: 40,
    fill: "rgba(34,124,157,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit-hover",
    d: "M24.39,10.467,20.9,6.972l1.146-1.147a1.528,1.528,0,0,1,1.16-.451,1.62,1.62,0,0,1,1.16.478l1.173,1.174a1.649,1.649,0,0,1,0,2.293ZM6.819,25.374A.794.794,0,0,1,6,24.555V22.207a.8.8,0,0,1,.055-.3.832.832,0,0,1,.191-.273L19.752,8.119l3.492,3.495L9.738,25.129a.831.831,0,0,1-.273.191.8.8,0,0,1-.3.055Z",
    transform: "translate(4 4.626)",
    fill: "#227c9d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenHover);
export default __webpack_public_path__ + "static/media/EditPenHover.696179ecdf0d1947dcd9c5d40c4b1589.svg";
export { ForwardRef as ReactComponent };